module.exports = __webpack_public_path__ + "static/parade-2020-house10-9d7de1f605b9333455a0f350cd57dac2.jpg";